import { useState } from 'react';

interface SafeImageProps {
  src: string;
  alt: string;
  className?: string;
  title?: string;
}

// Imagen tolerante a fallos: si la URL no es una imagen directa (p. ej. un
// enlace de Google Photos o Instagram), muestra un fallback con un enlace
// "Ver foto" en vez de una imagen rota.
export default function SafeImage({ src, alt, className, title }: SafeImageProps) {
  const [failed, setFailed] = useState(false);

  if (failed || !src) {
    return (
      <div
        className={`flex w-full h-full flex-col items-center justify-center gap-1 bg-background-100 text-foreground-400 ${
          className ?? ''
        }`}
      >
        <i className="ri-image-line text-2xl"></i>
        {src ? (
          <a
            href={src}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs underline hover:text-accent-600"
          >
            Ver foto
          </a>
        ) : (
          <span className="text-xs">Sin imagen</span>
        )}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      title={title}
      className={className}
      onError={() => setFailed(true)}
    />
  );
}